import { mantleMarkSrc } from '../components/logos/mantleLogo';

export const getMantleMarkFaviconHref = (): string => mantleMarkSrc();
